import React, { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Card, CardHeader, Col, Container, Row } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { useAuth } from "../../../_helper/Auth/AuthProvider";
import { useProject } from "../../../_helper/Projects/ProjectProvider";
import DashboardCard from "../../Card/DashboardCard";
import { HomeSkeleton } from "../../Skeleton/Skeleton";
import { NoData } from "../Ticket/NoData";

const HomePage = () => {
  const {
    searchText,
    getAllProjects,
    groupedAssets,
    getAssetTypes,
    setProjectAssetsList,
  } = useProject();
  const { authToken } = useAuth();
  const { country } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    if (authToken) {
      //getAllProjects(authToken)
      getAssetTypes(authToken, country);
      setProjectAssetsList([]);
    }
  }, [authToken, country]);

  // Check if any assets match the search
  const hasResults = Object.keys(groupedAssets).some((category) =>
    groupedAssets[category].some(
      (asset) =>
        asset.name.toLowerCase().includes(searchText.toLowerCase()) ||
        asset.beschreibung.toLowerCase().includes(searchText.toLowerCase())
    )
  );

  return (
    <Fragment>
      {/* <Breadcrumbs mainTitle="Home" parent="Pages" title="Home" /> */}
      <Container fluid={true}>
        <Row>
          <Col sm="12" md="10" className="offset-md-1">
            <Row style={{ marginTop: 30 }}>
              <Col sm="12">
                <Card className="text-center">
                  <CardHeader className="p-3 border-0 rounded-pill">
                    <H3> {t("Welcome to Report Portal")} </H3>
                  </CardHeader>
                </Card>
              </Col>
            </Row>

            {Object.keys(groupedAssets).length === 0 && <HomeSkeleton />}

            <Row style={{ marginBottom: 50 }}>
              <Col>
                {/* <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className="my-masonry-grid masonry-with-dec my-gallery gallery-with-description row grid"
                  columnClassName="col-xl-12 col-sm-12 col-md-12 grid-item"
                >
                  {Object.keys(groupedAssets).map((item, index) => (
                    <DashboardCard category={item} key={index} />
                  ))}
                </Masonry> */}

                {hasResults ? (
                  Object.keys(groupedAssets)
                    .sort((a, b) => a.localeCompare(b))
                    .map((item, index) => (
                      <DashboardCard category={item} key={index} />
                    ))
                ) : searchText.trim() !== "" ? (
                  <Card>
                    <NoData message="No results found" icon="fa-search-minus" />
                    {/* <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "300px", // full screen height
        width: "300px",  // full screen width
      }}
    >
      <div style={{ width: 300, height: 300 }}>
        <Lottie animationData={animationData} loop={true} />
      </div>
    </div> */}
                  </Card>
                ) : null}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default HomePage;
